import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Typeruns } from '../../../../../core/entities/typeruns.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsTyperunsComponent } from './dialogs-typeruns/edit-dialogs-typeruns/edit-dialogs-typeruns.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-typeruns',
  templateUrl: './typeruns.component.html',
  styleUrls: ['./typeruns.component.scss']
})
export class TyperunsComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  typerun: Typeruns = new Typeruns();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllTyperuns();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla typeruns
  */
  private getAllTyperuns(): void {
    this.loading = true;
    this.internalHomeService.allTyperuns().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un typerun
  * @param typerun Opcional. Typerun vacio.
  */
  public createTyperun(typerun?: Typeruns) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    typerun = this.typerun;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsTyperunsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { typerun, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllTyperuns();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un typerun
  * @param typerun Opcional. Typerun a editar.
  */
  public editTyperun(typerun?: Typeruns) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsTyperunsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { typerun, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllTyperuns();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un typerun
  * @param typerun Typerun a eliminar
  */
  public removeTyperun(typerun?: Typeruns) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_typeruns') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeTyperuns(typerun).subscribe(res => {
          console.log(res);
          this.getAllTyperuns();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
